<template>
  <div id="warehouse-registered-payment-method-page" class="payment">
    <div class="text-center">
      <h1 class="payment-title">プレミアムの登録をキャンセルしました</h1>
    </div>
    <div class="payment-content">
      <div class="m-b-xl">
        お手続きありがとうございます。<br>
        セラー様の操作によりプレミアムの登録手続きをキャンセルしました。<br>
      </div>
      <div class="m-b-xl">
        再度、お申込みになる場合はご利用プランページよりお手続きお願いします。
      </div>
      <div class="flexbox justify-center">
        <button class="btn btn-primary btn-shadow bd-rds-8" @click="$router.push({name: 'Setting', params: {tab: 'plan-info'}})">
          <i class="fa fa-arrow-circle-right fa-lg mr-r-5" aria-hidden="true"></i>
          ご利用プランを確認する
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      sessionId: null
    }
  },
  created () {
    this.sessionId = this.$route.query.session_id
    if (!this.sessionId) {
      this.$router.push('/not-found')
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.settings.plan_info_tab.upgrade_plan_cancel,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/UpgradePlanCanceled.vue